/*
 * Copyright (c) Microsoft Corporation. All rights reserved. Licensed under the MIT license.
 * See LICENSE in the project root for license information.
 */

// images references in the manifest
import "../../assets/icon-16.png";
import "../../assets/icon-32.png";
import "../../assets/icon-64.png";
import "../../assets/icon-80.png";
import * as $ from 'jquery';

/* global document, Office, Word */

Office.onReady(info => {
  if (info.host === Office.HostType.Word) {
    document.getElementById("sideload-msg").style.display = "none";
    document.getElementById("app-body").style.display = "flex";
    document.getElementById("run").onclick = () => tryCatch(run);
  }
});

const fontTabla = { bold: false, size: 10 };
let loadingPanel = $(".loading-panel");
let botonEnviar = $("#run");
let successPanel = $("#success-panel");
let errorPanel = $("#error-panel");
let formulario = $("#formulario");
const urlApi = "https://odk.magtel.es/api/v1/";
const proyecto = "3";
const formularioId = "ESP-DO-0001.1";
const identificador = "n_wo";

export async function run() {
  // Se muestra el Panel de carga y se deshabilita el botón Enviar
  loadingPanel.show();
  botonEnviar.prop("disabled", true);
  // Obtener Datos Formulario API
  const jsonResponse = await obtenerDatosAPI();
  // Obtener Foto Sede API
  const nombreFicheroSede = limpiarCadena(jsonResponse.data.definition.xml.FS.foto);
  var fotoSede = "";
  if (nombreFicheroSede === "") {
    fotoSede = "";
  } else {
    fotoSede = await obtenerFotoAPI(jsonResponse.data.instanceId, nombreFicheroSede);
  }
  // Obtener Reportaje Fotográfico
  const fotos = await obtenerFotosAPI(
    jsonResponse.data.instanceId,
    jsonResponse.data.definition.xml.Fotos.foto
  );

  await Word.run(async (context) => {
    // Cargar datos en variables desde el JSON
    var datosSede = jsonResponse.data.definition.xml.DS;
    // Se cargan las secciones del documento Word
    var mySections = context.document.sections;
    context.load(mySections, "body/style");
    // Se cambia el título del documento
    context.document.properties.title = getTitle(jsonResponse);

    return context.sync().then(function () {
      // Portada
      renderPortada(mySections, jsonResponse, datosSede, context);
      // Emcabezado
      renderEncabezado(mySections, jsonResponse, datosSede);
      // Tabla Sede
      renderTablaSede(mySections, datosSede);
      // Foto sede
      renderTablaFotoSede(mySections, fotoSede);
      // Reportaje Fotografico
      renderTablaFotos(mySections, fotos);
      // Tabla Bastidor
      renderTablaBastidor(mySections, jsonResponse);
      finishScript();

    });

    await context.sync();
  });
}

async function tryCatch(callback) {
  try {
    await callback();
  } catch (error) {
    loadingPanel.hide();
    errorPanel.show();
  }
}

async function obtenerDatosAPI() {
  const wo = $("#wo").val();
  const submitter = $("#submitter").val();
  const url = urlApi + "projects/" + proyecto + "/forms/" + formularioId + "/submission?identifier=" + identificador + "&value=" + wo + "&submitter=" + submitter;
  const myHeaders = new Headers();
  myHeaders.append("Content-type", "application/json");
  const myInit = {
    method: "GET",
    headers: myHeaders
  };
  const myRequest = new Request(url, myInit);
  const response = await fetch(myRequest);
  if (!response.ok) {
    throw new Error(response.statusText);
  }
  const jsonResponse = await response.json();

  return jsonResponse;
}

async function obtenerFotoAPI(instanceId, foto) {
  const url = urlApi + "submission/" + instanceId + "/attachment/" + foto + "?base64&height=300";

  const myHeaders = new Headers();
  myHeaders.append("Content-type", "application/json");
  const myInit = {
    method: "GET"
  };
  const myRequest = new Request(url, myInit);
  const response = await fetch(myRequest);
  if (!response.ok) {
    throw new Error(response.statusText);
  }
  const jsonResponse = await response.json();

  return jsonResponse.data;
}

async function obtenerFotosAPI(instanceId, fotos) {
  if (Array.isArray(fotos)) {
    let contador = 0;
    for (const foto of fotos) {
      var fotography = "";
      if (limpiarCadena(foto.foto) !== "") {
        fotography = await obtenerFotoAPI(instanceId, foto.foto);
      }
      fotos[contador].foto = fotography;
      fotos[contador].obs = limpiarCadena(fotos[contador].obs);
      contador++;
    }
    return fotos;
  } else {
    var fotograph = "";
    if (limpiarCadena(fotos.foto) !== "") {
      fotograph = await obtenerFotoAPI(instanceId, fotos.foto);
    }
    return { foto: fotograph, obs: limpiarCadena(fotos.obs) };
  }
}

function renderPortada(mySections, jsonResponse, datosSede, context) {
  const cod = limpiarCadena(datosSede.cod);
  const autor = limpiarCadena(jsonResponse.data.definition.xml.resp.Nombre);
  const codigo = getTitle(jsonResponse);
  const org = limpiarCadena(datosSede.organismo);
  const fechaFormato = getFechaFormato(jsonResponse.data.definition.xml.today);

  const tablaPortada = mySections.items[0].body.tables;
  tablaPortada
    .getFirst()
    .getCell(0, 0)
    .body.insertText(cod, Word.InsertLocation.end);
  tablaPortada
    .getFirst()
    .getCell(1, 1)
    .body.insertText(autor, Word.InsertLocation.end);
  tablaPortada
    .getFirst()
    .getCell(5, 1)
    .body.insertText(codigo, Word.InsertLocation.end);
  tablaPortada
    .getFirst()
    .getCell(7, 1)
    .body.insertText(cod + "/" + org, Word.InsertLocation.end);
  tablaPortada
    .getFirst()
    .getCell(8, 1)
    .body.insertText(fechaFormato, Word.InsertLocation.end);
}

function renderEncabezado(mySections, jsonResponse, datosSede) {
  const cod = limpiarCadena(datosSede.cod);
  const instanceName = limpiarCadena(jsonResponse.data.definition.xml.meta.instanceName);
  const org = limpiarCadena(datosSede.organismo);
  var myHeader = mySections.items[1].getHeader("Primary");
  const fechaFormato = getFechaFormato(jsonResponse.data.definition.xml.today);

  const tabla = myHeader.tables.getFirst();
  tabla.getCell(0, 0).body.insertText(cod, Word.InsertLocation.end);
  tabla.getCell(0, 1).body.insertText(instanceName, Word.InsertLocation.end);
  tabla.getCell(2, 0).body.insertText(fechaFormato, Word.InsertLocation.end);
  tabla.getCell(4, 1).body.insertText(cod + "/" + org, Word.InsertLocation.end);
}

function renderTablaFotoSede(mySections, fotoSede) {
  const tablaFotoSede = mySections.items[2].body.tables.getFirst().getNext();
  tablaFotoSede.addRows("End", 1);
  if (fotoSede !== "") {
    tablaFotoSede.getCell(1, 0).body.insertInlinePictureFromBase64(fotoSede, Word.InsertLocation.end);
  } else {
    tablaFotoSede.delete();
  }
}

function renderTablaSede(mySections, datosSede) {
  const org = limpiarCadena(datosSede.organismo);
  const cod = limpiarCadena(datosSede.cod);
  const name = limpiarCadena(datosSede.name);
  const cpos = limpiarCadena(datosSede.cod_postal);
  const local = limpiarCadena(datosSede.l_localizacion);
  const prov = limpiarCadena(datosSede.p_localizacion);
  const direc = limpiarCadena(datosSede.direccion);
  const coorx = limpiarCadena(datosSede.coor_x);
  const coory = limpiarCadena(datosSede.coor_y);

  const tabla = mySections.items[2].body.tables.getFirst();
  tabla.getCell(0, 1).body.insertText(cod, Word.InsertLocation.end);
  tabla.getCell(1, 1).body.insertText(name, Word.InsertLocation.end);
  tabla.getCell(2, 1).body.insertText(org, Word.InsertLocation.end);
  tabla.getCell(3, 1).body.insertText(cpos, Word.InsertLocation.end);
  tabla.getCell(4, 1).body.insertText(local, Word.InsertLocation.end);
  tabla.getCell(5, 1).body.insertText(prov, Word.InsertLocation.end);
  tabla.getCell(6, 1).body.insertText(direc, Word.InsertLocation.end);
  tabla.getCell(7, 1).body.insertText(coorx + " " + coory, Word.InsertLocation.end);
}

function renderTablaBastidor(mySections, jsonResponse) {
  const tablaBastidor = mySections.items[4].body.tables.getFirst();
  var tabla_CR = jsonResponse.data.definition.xml.CR.CR_tabla;
  if (Array.isArray(tabla_CR)) {
    recorreArrayTablaCR(tabla_CR, tablaBastidor);
  } else {
    escribeFilaBastidor(tabla_CR, tablaBastidor, 1);
  }
}

function recorreArrayTablaCR(tabla, tablaBastidor) {
  let contador = 1;
  tabla.forEach((bastidor) => {
    escribeFilaBastidor(bastidor, tablaBastidor, contador);
    contador++;
  });
}

function escribeFilaBastidor(tabla_CR, tablaBastidor, contador) {
  const equipo = limpiarCadena(tabla_CR.equipo);
  const modelo = limpiarCadena(tabla_CR.modelo);
  const conversor = limpiarCadena(tabla_CR.conversor);
  const p_conexion = limpiarCadena(tabla_CR.p_conexion);
  const m_equipolan = limpiarCadena(tabla_CR.m_equipolan);
  const co_redlan = limpiarCadena(tabla_CR.co_redlan);
  const conversor_lan = limpiarCadena(tabla_CR.conversor_lan);

  tablaBastidor.addRows("End", 1);
  tablaBastidor.getCell(contador, 0).body.insertText(equipo, Word.InsertLocation.end);
  tablaBastidor.getCell(contador, 0).body.paragraphs.getFirst().font.set(fontTabla);
  tablaBastidor.getCell(contador, 1).body.insertText(modelo, Word.InsertLocation.end);
  tablaBastidor.getCell(contador, 1).body.paragraphs.getFirst().font.set(fontTabla);
  tablaBastidor.getCell(contador, 2).body.insertText(conversor, Word.InsertLocation.end);
  tablaBastidor.getCell(contador, 2).body.paragraphs.getFirst().font.set(fontTabla);
  tablaBastidor.getCell(contador, 3).body.insertText(p_conexion, Word.InsertLocation.end);
  tablaBastidor.getCell(contador, 3).body.paragraphs.getFirst().font.set(fontTabla);
  tablaBastidor.getCell(contador, 4).body.insertText(m_equipolan, Word.InsertLocation.end);
  tablaBastidor.getCell(contador, 4).body.paragraphs.getFirst().font.set(fontTabla);
  tablaBastidor.getCell(contador, 5).body.insertText(co_redlan, Word.InsertLocation.end);
  tablaBastidor.getCell(contador, 5).body.paragraphs.getFirst().font.set(fontTabla);
  tablaBastidor.getCell(contador, 6).body.insertText(conversor_lan, Word.InsertLocation.end);
  tablaBastidor.getCell(contador, 6).body.paragraphs.getFirst().font.set(fontTabla);
}

function renderTablaFotos(mySections, fotos) {
  const tabla = mySections.items[3].body.tables.getFirst();
  if (Array.isArray(fotos)) {
    renderArrayFotos(tabla, fotos);
  } else {
    renderFoto(tabla, fotos, 1);
  }
}

function renderArrayFotos(tabla, fotos) {
  let contador = 1;
  fotos.forEach((foto) => {
    renderFoto(tabla, foto, contador);
    contador++;
  });
}

function renderFoto(tabla, fotoObject, contador) {
  tabla.addRows("End", 1);
  if (fotoObject.foto !== "") {
    tabla.getCell(contador, 0).body.insertInlinePictureFromBase64(fotoObject.foto, Word.InsertLocation.end);
  }
  tabla.getCell(contador, 1).body.insertText(fotoObject.obs, Word.InsertLocation.end);
  tabla.getCell(contador, 1).body.paragraphs.getFirst().font.set(fontTabla);
  tabla.getCell(contador, 1).body.paragraphs.getFirst().alignment = "Justified";
}

function limpiarCadena(dato) {
  if (Array.isArray(dato) && dato.length === 0) {
    return "";
  }

  return dato;
}

function finishScript() {
  loadingPanel.hide();
  successPanel.show();
  formulario.hide();
}

function getTitle(jsonResponse) {
  const instanceName = limpiarCadena(jsonResponse.data.definition.xml.meta.instanceName);
  const instanceSinFecha = limpiarCadena(instanceName.substring(10));
  const fecha = limpiarCadena(instanceName.substring(0, 10).split("-").join(""));
  const codigo = limpiarCadena(fecha + instanceSinFecha);

  return codigo;
}

function getFechaFormato(today) {
  const fecha = limpiarCadena(today);
  const date = new Date(fecha);
  const dia = date.getDate().toString().padStart(2, '0');
  const mes = (date.getMonth() + 1).toString().padStart(2, '0');
  const year = date.getFullYear();

  return dia + "/" + mes + "/" + year;
}